import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import Search from "../assets/search.png";
import DatePicker from "react-datepicker";
import { ArrowLeft } from "lucide-react";
import { GuestManagementPageText } from "../CommonJquery/WebsiteText.js";
import {
  server_post_data,
  get_car_maintanance_report,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  goBack,
  formatToYYYYMMDD,
  sortByCarTaglineAscending,
} from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";
function MaintananceReport() {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  // Set initial state using useState hook
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    const sevenDaysLater = new Date();
    sevenDaysLater.setDate(today.getDate() + 7);
    return sevenDaysLater;
  });
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [flagData, setflagData] = useState("1");
  const [selectedValue, setSelectedValue] = useState("Name"); // State to hold the selected value
  const handleSelect = (event) => {
    setSelectedValue(event.target.value); // Update the selected value when an option is selected
  };
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    ? sortByCarTaglineAscending(filteredData).slice(
        indexOfFirstItem,
        indexOfLastItem
      )
    : [];
  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  //console.log("currentItems:", currentItems);

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  }, []);

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    setCurrentPage(1);
    master_data_get(startDate, endDate, flag, call_id);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("start_date", formatToYYYYMMDD(start_date));
    fd.append("end_date", formatToYYYYMMDD(end_date));
    // fd.append("flag", flag);
    // fd.append("call_id", call_id);
    // fd.append("search_option", selectedValue);
    // fd.append("search_data", document.getElementById("search_data").value);
    await server_post_data(get_car_maintanance_report, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log("Console:", Response.data.message);

          seteditStaffData(Response.data.message.report_data);
          setfilteredData(Response.data.message.report_data);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // const handleSearch = (event) => {
  //   const searchValue = event.target.value;
  //   setSearchFilter(searchValue);
  //   setCurrentPage(1);
  //   // Filter table data based on search value
  //   const filteredDatashow = editStaffData.filter((row) => {
  //     return Object.values(row).some((value) => {
  //       if (value !== null && value !== undefined) {
  //         // Add null check here
  //         return (
  //           typeof value === "string"
  //             ? value.toLowerCase()
  //             : value.toString().toLowerCase()
  //         ).includes(searchValue.toLowerCase());
  //       }
  //       return false;
  //     });
  //   });

  //   setfilteredData(filteredDatashow);
  // };

  const handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchFilter(searchValue);
    setCurrentPage(1);

    const filteredDatashow = editStaffData.filter((row) => {
      const driver = filteredDatashow || {};

      const fieldsToSearch = [
        driver.car_tagline,
        driver.oil_level,
        driver.oil_quantity,
        driver.odo_metter,
        driver.last_odometer_reading,
        driver.current_odometer_reading,
        driver.oil_added_quantity,
        driver.notes_for_future,
        driver.driver_name,
        // driver.servicedue ,
      ];

      return fieldsToSearch.some((field) =>
        field?.toString().toLowerCase().includes(searchValue)
      );
    });

    setfilteredData(filteredDatashow);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const applySorting = (data, field, order) => {
    return [...data].sort((a, b) => {
      const aBooking = a.booking_details?.[0] || {};
      const bBooking = b.booking_details?.[0] || {};

      const getValue = (row) => {
        const booking = row.booking_details?.[0] || {};
        switch (field) {
          case "dues":
            return booking.total_due || 0;
          case "per_day_rate":
            return booking.per_day_rent || 0;
          case "rent":
            return row.rent || 0;
          case "total_amount":
            return row.total_amount || 0;
          case "advance":
            return row.deposit || 0;
          case "tolls":
            return row.tolls || 0;
          case "damage":
            return row.damagefees || 0;
          default:
            return 0;
        }
      };

      const aVal = getValue(a);
      const bVal = getValue(b);

      return order === "asc" ? aVal - bVal : bVal - aVal;
    });
  };

  const downloadMaintenanceCSV = () => {
    const headers = [
      "Service Due",
      "Day",
      "Fleet No.",
      "Driver Name",
      "Oil Level",
      "Oil Quality",
      "O/C ODO",
      "Last ODO",
      "Diff O/C",
      "Oil Added Quantity (Qt)",
      "Notes for Future",
    ];

    const rows = filteredData.map((item) => [
      formatDate(item.servicedue) || "",
      item.car_tagline || "",
      item.driver_name || "",
      item.oil_level || "",
      item.oil_quantity || "",
      item.odo_metter || "",
      item.last_odometer_reading || "",
      item.odo_metter - item.last_odometer_reading || "",
      item.oil_added_quantity || 0,
      item.notes_for_future || "",
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows]
        .map((row) =>
          row.map((field) => `"${String(field).replace(/"/g, '""')}"`).join(",")
        )
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "maintenance_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const formatDate = (isoDateString) => {
    const date = new Date(isoDateString);

    const options = {
      weekday: "short", // e.g., "Mon"
      year: "numeric", // e.g., "2025"
      month: "numeric", // e.g., "7"
      day: "numeric", // e.g., "21"
    };

    return date.toLocaleDateString("en-US", options);
  };

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}

      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <p className="breadcrumb-item">Maintanance Reports</p>
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div>
              <div className={` alignCol bottomAlgin col-xl-3 mb-0`}>
                <div className="pageActionBtns">
                  <button
                    className="CSVBTN"
                    style={{ height: "38px" }}
                    onClick={downloadMaintenanceCSV}
                  >
                    Download Excel
                  </button>
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="viewStaff">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.Start_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={startDate}
                          onChange={handleDateChange}
                          className="form-control input_field_custom4"
                          // maxDate={endDate}
                          // minDate={startDate}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.End_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          className="form-control input_field_custom4"
                          // maxDate={endDate}
                          // minDate={startDate}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-lg-1 col-sm-2 bottomAlgin">
                      <div className="inputDiv2 p-0">
                        <button
                          type="button"
                          className="btnSearch w-100 h-100"
                          style={{ left: "auto", right: "auto" }}
                          onClick={() => search_data()}
                        >
                          {GuestManagementPageText.Search_text}
                        </button>
                      </div>
                    </div>

                    <div
                      className="col-xl-3 col-md-4 bottomAlgin"
                      style={{ marginLeft: "auto", marginRight: "0" }}
                    >
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={Search} alt="Rapid Car Leasing" />
                        </label>
                        <input
                          type="text"
                          placeholder={GuestManagementPageText.Guest_Filter}
                          value={searchfilter}
                          // onInput={handleIaphabetnumberChange}
                          onChange={(e) => handleSearch(e)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ padding: "0 10px" }}>
                  <div className="cust_hist_card" style={{ padding: "0 10px" }}>
                    <div className="reservationHistoryTable">
                      <div
                        className="historyTableContainer stickyTableheigh274"
                        style={{ overflowX: "auto" }}
                      >
                        <table className="table margin_class_table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">Sr.No.</th>
                              <th scope="col">Service Due</th>
                              <th scope="col">Fleet No.</th>
                              <th scope="col">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <span className="fontWeight600">
                                    Driver Name
                                  </span>
                                </div>
                              </th>
                              <th scope="col">Oil Level</th>
                              <th scope="col">Oil Quality</th>
                              <th scope="col">O/C ODO</th>
                              <th scope="col">Last ODO</th>
                              <th scope="col">Diff ODO</th>
                              <th scope="col">Oil Added(Qt)</th>
                              <th scope="col">Notes for Future</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems && currentItems.length > 0 ? (
                              currentItems.map((option, index) => (
                                <tr
                                  className="historyTableRow h-auto"
                                  key={index}
                                >
                                  <td>
                                    <div
                                      className="historyTableRowText justify-content-start height50 historyName"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {formatDate(option.servicedue)}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option.car_tagline}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      <strong>{option?.name}</strong>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.oil_level}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.oil_quantity}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText mb-2 justify-content-start height50 historyName">
                                      <p>{option?.odo_metter || 0}</p>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText mb-2 justify-content-start height50 historyName">
                                      <p>
                                        {option?.last_odometer_reading || 0}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText mb-2 justify-content-start height50 historyName">
                                      <p>
                                        {option?.odo_metter -
                                          option?.last_odometer_reading || 0}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.oil_added_quantity}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.notes_for_future}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={11} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <div className="cust_hist_card_footer">
                          <div className="cust_hist_pagination_info">
                            {filteredData && filteredData.length > 0 ? (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  {indexOfFirstItem + 1}
                                </span>{" "}
                                to{" "}
                                <span className="cust_hist_pagination_bold">
                                  {Math.min(
                                    indexOfLastItem,
                                    filteredData.length
                                  )}
                                </span>{" "}
                                of{" "}
                                <span className="cust_hist_pagination_bold">
                                  {filteredData.length}
                                </span>{" "}
                                Drivers
                              </>
                            ) : (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  0
                                </span>{" "}
                                Driver
                              </>
                            )}
                          </div>
                          <div className="cust_hist_pagination">
                            <nav aria-label="Pagination">
                              <ul className="cust_hist_pagination_list">
                                {renderPaginationButtons()}
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaintananceReport;
